import React from 'react'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';
import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
import { blue } from '@mui/material/colors';
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import AvatarPic from "../../assets/images/avtarPic.png";
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
// import FavoriteIcon from '@mui/icons-material/Favorite';
import ReplyIcon from '@mui/icons-material/Reply';
// import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import ForumIcon from '@mui/icons-material/Forum';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
  
function MobileDiscussionForum() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div className='MainView'> 
    <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
        className="backArrowMobil"
        onClick={() => navigate("/MobileDashboard")}
        />
        <h1>Discussion Forum</h1>
    </div>
    <div className='topSpace'></div>
    <div className='SearchSortDiv'>
        <input type='text' placeholder='Search' />
        <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        >
        <SortOutlinedIcon sx={{ fontSize: 30, color: blue[800] }} />
      </IconButton>
      <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleClose}>
            Oldest to Newest
          </MenuItem>
          <MenuItem onClick={handleClose}>
            Newest to Oldest
          </MenuItem>
      </Menu>
    </div>
    <div className='mainWrapperListView'>
    <div className="famDetailsListInrMob">
        <div className="famDetailsListTo" onClick={()=>navigate('/MobileDiscussionDetails')}>
          <div className="alignfamDetailsListToPro">
            <div className="ImageViewRound">
              <img src={AvatarPic} alt='altimg'/>
            </div>
            <div className="detailsDiMob">
              <h1>User Name</h1>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
          <div>
          <p className='ticketTimedeteTxt'>Time & Date</p>
          <p className='pollTimeTxt'>20/07/2024 10:30 Am</p>
          </div>
        </div>
        <div className='pollsTitlDescView margineTop10'>
          <p className='pollsDescripTxt'>Description Description Description Description</p>
        </div>
        <div className='dividerCommon' />
        <div className='forumIconView'>
            <div className='iconWithCount'>
                <FavoriteBorderIcon sx={{fontSize:22}}/>
                <p className='formCountTxt'>5</p>
            </div>
            <div className='iconWithCount'>
                <ReplyIcon sx={{fontSize:25, color:'#0047cb'}}/>
                <p className='formCountTxt'>5</p>
            </div>
            <div className='iconWithCount'>
                <ForumIcon sx={{fontSize:22, color:'#0047cb'}}/>
                <p className='formCountTxt'>5</p>
            </div>
        </div>
       
    </div>
      <div className='flaotBtnAdd'>
        <Fab onClick={()=>navigate('/MobileCreateDiscussionForum')} size="medium" sx={{backgroundColor: '#3853ec'}} aria-label="add" >
          <AddIcon sx={{fontSize: 32, color:'white'}}/>
        </Fab>
      </div>
    </div>
    </div>
  )
}

export default MobileDiscussionForum